export default "__VITE_ASSET__9d5cd7b9__"